import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import { computed } from 'vue';
    import CheckBoxInput from '@fr/vue/components/inputs/CheckBoxInput.vue';
    import { useViewport } from '@travelata-libs/utils';

    interface EmiratesFilterCheckboxProps {
        modelValue: boolean;
        isVisible?: boolean;
    }

    interface EmiratesFilterCheckboxEmits {
        (event: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EmiratesFilterCheckbox',
  props: {
    modelValue: { type: Boolean },
    isVisible: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (event: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, isVisible: boolean }

    

    

    const model = computed({
        get: () => props.modelValue,
        set: (value) => {
            emit('update:modelValue', value);
        }
    });

    const { isMobile } = useViewport();


return { __sfc: true,emit, props, model, isMobile, CheckBoxInput }
}

})